import { vueThemingProps } from '@chakra-ui/vue-utils';
import { defineComponent, computed, h } from 'vue';
import { useStyleConfig, chakra } from '@chakra-ui/vue-system';
import { filterUndefined } from '@chakra-ui/utils';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var CCode = defineComponent({
  props: _extends({
    as: {
      type: [Object, String],
      "default": "code"
    }
  }, vueThemingProps),
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        attrs = _ref.attrs;
    return function () {
      var themingProps = computed(function () {
        return filterUndefined({
          colorScheme: props.colorScheme,
          variant: props.variant,
          size: props.size,
          styleConfig: props.styleConfig
        });
      });
      var styles = useStyleConfig("Code", themingProps.value);
      return h(chakra(props.as, {
        __css: _extends({
          display: "inline-block",
          verticalAlign: "middle",
          fontSize: "sm",
          px: "0.2em",
          fontFamily: "mono",
          rounded: "sm"
        }, styles.value)
      }), attrs, slots);
    };
  }
});
var CCode$1 = CCode;

export { CCode$1 as CCode };
